import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FaturamentoService } from 'src/app/services/http/faturamento.service';
import { first, distinctUntilChanged, debounceTime, filter, debounce } from 'rxjs/operators';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { DetalhamentoFaturaClienteConsulta } from 'src/app/models/detalhamento-fatura-cliente-consulta';
import { DetalhamentoFaturaCliente } from 'src/app/models/detalhamento-fatura-cliente';
import { UtilValidators } from 'src/app/utils/util-validators';
import { UtilMasks } from 'src/app/utils/util-masks';
import { Utils } from 'src/app/utils/utils';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { DetalhamentoFaturaClienteLaudo } from 'src/app/models/detalhamento-fatura-cliente-laudo';
import { EnderecoService } from 'src/app/services/http/endereco.service';
import { LoginService } from 'src/app/services/login.service';
import { Usuario } from 'src/app/models/usuario-login';

@Component({
  selector: 'app-faturamento-detalhamento-cliente',
  templateUrl: './faturamento-detalhamento-cliente.component.html',
  styleUrls: ['./faturamento-detalhamento-cliente.component.scss']
})
export class FaturamentoDetalhamentoClienteComponent implements OnInit {
  idFaturamento: string;
  idCliente: string;

  tableLoading: boolean = false;

  faturaCliente: DetalhamentoFaturaCliente;
  listaConsulta: FormGroup[] = [];
  listaCortesia: FormGroup[] = [];
  listaLaudo: FormGroup[] = [];
  listaDesconto: FormGroup[] = [];

  listaDescontoRemover: number[] = [];

  masks = {
    decimal: { mask: UtilMasks.decimal, guide: false },
    cep: { guide: false, mask: UtilMasks.cep },
    telefone: { guide: false, mask: UtilMasks.telefone },
  }

  form = new FormGroup({
    razaoSocial: new FormControl('', [Validators.required]),
    nomeFantasia: new FormControl('', [Validators.required]),
    documento: new FormControl('', [Validators.required]),
    telefone: new FormControl('', []),
    email: new FormControl('', [Validators.required]),
    referencia: new FormControl('', [Validators.required]),

    rua: new FormControl('', [Validators.required]),
    bairro: new FormControl('', [Validators.required]),
    cidade: new FormControl('', [Validators.required]),
    estado: new FormControl('', [Validators.required]),
    numero: new FormControl('', [Validators.required]),
    cep: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
  });
  usuario: Usuario;

  constructor(private activedRoute: ActivatedRoute,
    private router: Router,
    private faturamentoService: FaturamentoService,
    private enderecoService: EnderecoService,
    private msgModal: ModalMsgService,
    private loginService: LoginService) {
    this.loginService.getLogIn().subscribe(l => this.usuario = l);
    if (!this.usuario.permissoes.faturamento_matriz) {
      this.router.navigate(['error/401'])
    }
    this.activedRoute.params.pipe(first()).subscribe(r => {
      this.idFaturamento = r.idFaturamento || null;
      this.idCliente = r.idCliente || null;
    });
  }

  ngOnInit() {
    this.faturamentoService.carregarDetalhesFaturamentoCliente(this.idFaturamento, this.idCliente).then(result => {
      this.faturaCliente = result;

      this.form.patchValue({
        razaoSocial: this.faturaCliente.razaoSocial,
        nomeFantasia: this.faturaCliente.nomeFantasia,
        documento: this.faturaCliente.documento,
        telefone: this.faturaCliente.telefone,
        email: this.faturaCliente.email,
        referencia: this.faturaCliente.mesReferencia + "/" + this.faturaCliente.anoReferencia,

        rua: this.faturaCliente.rua,
        bairro: this.faturaCliente.bairro,
        cidade: this.faturaCliente.cidade,
        estado: this.faturaCliente.estado,
        numero: this.faturaCliente.numero,
        cep: this.faturaCliente.cep,
      });

      this.form.controls.cep.valueChanges
        .pipe(
          distinctUntilChanged(),
          debounceTime(400),
          filter(v => v.length == 10)
        )
        .subscribe(v => {
          let cep = v;
          this.enderecoService.pesquisaCEP(cep).then(r => {
            if (r.erro) {
              this.msgModal.openDialog('CEP NÃO ENCONTRADO', 'Verifique o CEP informado, caso ele esteja correto preencha os campos manualmente', 'danger');
            } else {
              this.form.controls.rua.patchValue(r.rua);
              this.form.controls.bairro.patchValue(r.bairro);
              this.form.controls.cidade.patchValue(r.cidade);
              this.form.controls.estado.patchValue(r.estado);
            }
          }).catch(e => { });
        });

      this.listaConsulta = this.faturaCliente.listaConsulta.map(c => this.addConsultaItemConsulta(c));
      this.listaCortesia = this.faturaCliente.listaCortesia.map(c => this.addConsultaItemConsulta(c));
      this.listaLaudo = this.faturaCliente.listaLaudo.map(c => this.addConsultaItemLaudo(c));

      this.listaDesconto = this.faturaCliente.listaDesconto.map(c => this.addDescontoItem(c.id, c.valor, c.descricao, c.tipo));
    });
  }

  valorConsulta() {
    let valorFinal = 0;
    if (this.listaConsulta != null && this.listaConsulta.length > 0) {
      let valorConsulta = this.listaConsulta.map(item => parseFloat(Utils.stringToNumber(item.value.valorUnitario)) * item.value.quantidade).reduce((a, b) => a + b, 0);
      valorFinal += valorConsulta;
    }

    return valorFinal;
  }

  valorCortesia() {
    let valorFinal = 0;
    if (this.listaCortesia != null && this.listaCortesia.length > 0) {
      let valorCortesia = this.listaCortesia.map(item => parseFloat(Utils.stringToNumber(item.value.valorUnitario)) * item.value.quantidade * -1).reduce((a, b) => a + b, 0);
      valorFinal += valorCortesia;
    }

    return valorFinal;
  }

  valorLaudo() {
    let valorFinal = 0;
    if (this.listaLaudo != null && this.listaLaudo.length > 0) {
      let valorLaudo = this.listaLaudo.map(item => parseFloat(Utils.stringToNumber(item.value.valorUnitario)) * item.value.quantidade).reduce((a, b) => a + b, 0);
      valorFinal += valorLaudo;
    }

    return valorFinal;
  }

  valorDescontos() {
    let valorFinal = 0;
    if (this.listaDesconto != null && this.listaDesconto.length > 0) {
      let valorDesconto = this.listaDesconto.map(item => {
        let valorItem = parseFloat(Utils.stringToNumber(item.value.valor));
        return item.value.tipo == "DESCONTO" ? valorItem * -1 : valorItem;
      }).reduce((a, b) => a + b, 0);
      valorFinal += valorDesconto;
    }

    return valorFinal;
  }

  valorTotal() {
    let valorFinal = 0;

    valorFinal += this.valorConsulta();
    valorFinal += this.valorCortesia();
    valorFinal += this.valorLaudo();
    valorFinal += this.valorDescontos();

    return valorFinal;
  }

  valorTotalProduto(quantidade: number, valor: string) {
    if (valor == null || valor.length == 0 || quantidade == null || quantidade == 0)
      return 0;
    return Utils.stringToNumber(valor) * quantidade;
  }

  addConsultaItemConsulta(detalhe: DetalhamentoFaturaClienteConsulta) {

    if (typeof detalhe.valorUnitario == 'number') {
      detalhe.valorUnitario = Utils.numberToString(detalhe.valorUnitario);
    }

    //, UtilValidators.decimalMin(0.01)
    return new FormGroup({
      id: new FormControl(detalhe.id, [Validators.required]),
      valorUnitario: new FormControl(detalhe.valorUnitario, [Validators.required, UtilValidators.decimal]),
      nomeConsulta: new FormControl(detalhe.nomeConsulta, [Validators.required]),
      quantidade: new FormControl(detalhe.quantidade, [Validators.required]),
      atualizarTabelaPreco: new FormControl(false, [Validators.required]),
      cortesia: new FormControl(detalhe.cortesia, [Validators.required]),
    });
  }

  addDescontoItem(id = null, valor = 0, descricao = "", desconto = "DESCONTO") {
    if (typeof valor == 'number') {
      valor = Utils.numberToString(valor);
    }

    return new FormGroup({
      id: new FormControl(id, []),
      tipo: new FormControl(desconto, [Validators.required]),
      valor: new FormControl(valor, [Validators.required, UtilValidators.decimal, UtilValidators.decimalMin(0.01)]),
      descricao: new FormControl(descricao, [Validators.required]),
    })
  }

  addDesconto(id = null, valor = 0, descricao = "", desconto = "DESCONTO") {
    this.listaDesconto.push(this.addDescontoItem(id, valor, descricao, desconto));
  }

  removerDesconto(index) {
    let indiceDesconto = this.listaDesconto[index];
    if (indiceDesconto.value.id != null) {
      this.listaDescontoRemover.push(indiceDesconto.value.id);
    }
    this.listaDesconto.splice(index, 1);
  }

  addConsultaItemLaudo(detalhe: DetalhamentoFaturaClienteLaudo) {

    if (typeof detalhe.valorUnitario == 'number') {
      detalhe.valorUnitario = Utils.numberToString(detalhe.valorUnitario);
    }
    return new FormGroup({
      id: new FormControl(detalhe.id, [Validators.required]),
      valorUnitario: new FormControl(detalhe.valorUnitario, [Validators.required, UtilValidators.decimal, UtilValidators.decimalMin(0.00)]),
      nomeLaudo: new FormControl(detalhe.nomeLaudo, [Validators.required]),
      quantidade: new FormControl(detalhe.quantidade, [Validators.required]),
      atualizarTabelaPreco: new FormControl(false, [Validators.required]),
    });
  }

  validarFormConsulta() {
    let errorCount = 0;

    this.listaConsulta.forEach(c => {
      if (c.invalid)
        errorCount++;
    });

    this.listaCortesia.forEach(c => {
      if (c.invalid)
        errorCount++;
    });

    this.listaLaudo.forEach(c => {
      if (c.invalid)
        errorCount++;
    });

    this.listaDesconto.forEach(c => {
      if (c.invalid)
        errorCount++;
    });
    return errorCount;
  }

  validarFormConsultaZerada() {
    let errorCount = 0;

    this.listaConsulta.forEach(c => {
      var numberValue = parseFloat(Utils.stringToNumber(c.controls.valorUnitario.value));
      if (isNaN(numberValue)) {
        numberValue = 0.00;
      }

      if (numberValue <= 0.00)
        errorCount++;
    });

    return errorCount;
  }

  formatJson() {


    let data = {
      ...this.faturaCliente,
      ...this.form.value,
      listaConsulta: [
        ...this.listaConsulta.map(item => ({
          ...item.value,
          valorUnitario: parseFloat(Utils.stringToNumber(item.value.valorUnitario)),
          valorTotal: parseFloat(Utils.stringToNumber(item.value.valorUnitario)) * item.value.quantidade
        }))
      ],
      listaCortesia: [
        ...this.listaCortesia.map(item => ({
          ...item.value,
          valorUnitario: parseFloat(Utils.stringToNumber(item.value.valorUnitario)),
          valorTotal: parseFloat(Utils.stringToNumber(item.value.valorUnitario)) * item.value.quantidade
        }))
      ],
      listaLaudo: [
        ...this.listaLaudo.map(item => ({
          ...item.value,
          valorUnitario: parseFloat(Utils.stringToNumber(item.value.valorUnitario)),
          valorTotal: parseFloat(Utils.stringToNumber(item.value.valorUnitario)) * item.value.quantidade
        }))
      ],
      listaDesconto: [
        ...this.listaDesconto.map(item => ({
          ...item.value,
          valor: parseFloat(Utils.stringToNumber(item.value.valor))
        }))
      ],
      listaDescontoRemover: [
        ...this.listaDescontoRemover
      ]
    }

    return data;
  }

  sendForm() {
    if (this.form.invalid || this.validarFormConsulta() > 0) {
      Object.keys(this.form.controls).forEach(c => this.form.get(c).markAsTouched());
      this.listaConsulta.forEach(lc => { Object.keys(lc.controls).forEach(c => lc.get(c).markAsTouched()) });
      this.listaCortesia.forEach(lc => { Object.keys(lc.controls).forEach(c => lc.get(c).markAsTouched()) });
      this.listaLaudo.forEach(lc => { Object.keys(lc.controls).forEach(c => lc.get(c).markAsTouched()) });
      this.listaDesconto.forEach(lc => { Object.keys(lc.controls).forEach(c => lc.get(c).markAsTouched()) });
      this.msgModal.openDialog('Preencha todos os campos corretamente',
        'Verifique os erros em vermelho e corrija as informações de acordo com o solicitado', 'danger')
      return;
    }

    if (this.validarFormConsultaZerada() > 0) {
        this.msgModal.openDialogQuestion('!!! Atenção Financeiro !!!',
        'Existem Valores Zerados em consultas realizadas, Deseja continuar ?', 'danger').then(resp => {

          if (resp == 'cancel') {
            this.msgModal.openDialog('Processo Cancelado',
              'Realize os ajustes necessários e tente novamente!', 'success');
          } else {
            let data = this.formatJson();
            this.faturamentoService.atualizarTabelaPreco(data).then(result => {
              this.router.navigate(['faturamento', 'detalhe', this.idFaturamento]);
            });
          }

        });
    }else{
      let data = this.formatJson();
      this.faturamentoService.atualizarTabelaPreco(data).then(result => {
        this.router.navigate(['faturamento', 'detalhe', this.idFaturamento]);
      });

    }
  }

  voltar(){
    this.router.navigate(['faturamento', 'detalhe', this.idFaturamento]);
  }

}
